var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "has-background-dark tile-border" },
    [
      _c(
        "DashboardPanel",
        [
          _c(
            "div",
            {
              staticClass:
                "panel-heading has-text-centered has-text-white custom-panel-heading",
            },
            [_vm._v("MESSAGE INBOX")]
          ),
          _c("DashboardProgressBar", {
            attrs: {
              "is-loading": _vm.isLoading,
              "initial-color": "#6C757D",
              "loading-color": "#1c1c1b",
            },
          }),
          _c("div", { staticClass: "tabs" }, [
            _c("ul", { staticClass: "tab-list tab-override" }, [
              _c(
                "li",
                {
                  class: [
                    {
                      "item-border": _vm.activeTab === _vm.dashboardTabs.Today,
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.filterMessage(_vm.dashboardTabs.Today)
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "item",
                      class: [
                        {
                          "item-active":
                            _vm.activeTab === _vm.dashboardTabs.Today,
                        },
                      ],
                    },
                    [_vm._v("Today")]
                  ),
                ]
              ),
              _c(
                "li",
                {
                  class: [
                    {
                      "item-border":
                        _vm.activeTab === _vm.dashboardTabs.Yesterday,
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.filterMessage(_vm.dashboardTabs.Yesterday)
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "item",
                      class: [
                        {
                          "item-active":
                            _vm.activeTab === _vm.dashboardTabs.Yesterday,
                        },
                      ],
                    },
                    [_vm._v("Yesterday")]
                  ),
                ]
              ),
              _c(
                "li",
                {
                  class: [
                    {
                      "item-border":
                        _vm.activeTab === _vm.dashboardTabs.ThisWeek,
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.filterMessage(_vm.dashboardTabs.ThisWeek)
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "item",
                      class: [
                        {
                          "item-active":
                            _vm.activeTab === _vm.dashboardTabs.ThisWeek,
                        },
                      ],
                    },
                    [_vm._v("This Week")]
                  ),
                ]
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "message-container",
              class: {
                "container-fullscreen": _vm.isUninvoicedJobsAndChartDisabled,
              },
            },
            [
              _vm.filteredMessages.length === 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "notification has-background-black has-text-centered",
                    },
                    [_c("span", [_vm._v("No Messages")])]
                  )
                : _vm._e(),
              _vm._l(_vm.filteredMessages, function (message, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass:
                      "container has-background-black has-text-grey m-2 p-2",
                    class: [{ "message-border": !message.isRead }],
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "is-flex is-justify-content-space-between is-align-items-center mb-2",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "is-flex is-align-items-center has-text-white",
                          },
                          [
                            _c("span", { staticClass: "icon mr-2" }, [
                              _c("i", {
                                class: _vm.getIconCss(message.notificationType),
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]),
                            _c(
                              "a",
                              {
                                key: index,
                                staticClass: "route-link",
                                on: {
                                  click: function ($event) {
                                    return _vm.gotoRoute(
                                      message.quoteId,
                                      message.notificationType
                                    )
                                  },
                                },
                              },
                              [_vm._v(" #" + _vm._s(message.quoteNoRef) + " ")]
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "help is-italic m-0" }, [
                          _vm._v(_vm._s(_vm.getSender(message))),
                        ]),
                        _c("span", { staticClass: "help is-italic m-0" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatDateTimeLocale(
                                message.createdDate,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "message has-background-black has-text-grey",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "message-line has-text-white",
                            class: [
                              {
                                "has-text-weight-bold message-line":
                                  !message.isRead,
                              },
                            ],
                          },
                          [_vm._v(" " + _vm._s(_vm.getContent(message)) + " ")]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "is-flex is-justify-content-end" },
                      [
                        _c(
                          "div",
                          { staticClass: "is-flex is-align-items-center" },
                          [
                            message.isRead
                              ? _c(
                                  "span",
                                  { staticClass: "is-flex help is-italic" },
                                  [_vm._v("Read by " + _vm._s(message.readBy))]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "is-flex is-clickable ml-1",
                                on: {
                                  click: function ($event) {
                                    return _vm.setMessageStatus(
                                      message,
                                      message.notificationType
                                    )
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  !message.isRead
                                    ? _c("i", {
                                        staticClass:
                                          "mdi mdi-message has-text-info",
                                      })
                                    : _vm._e(),
                                  message.isRead
                                    ? _c("i", {
                                        staticClass:
                                          "mdi mdi-message-check-outline has-text-white",
                                      })
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }